/**
 * Onboarding holdout feature: gate onboarding behind a 24h cooldown, a max of 3 exposures,
 * and don't-show-again-after-completion. This module defines the holdout tunables
 * (cooldown, exposure cap, storage key) and the persisted state shape. State is read/written
 * via the get/persist helpers using AtlBrowserStorageLocal; if productionized, consider a more
 * permanent source (e.g. backend or user preferences).
 */
import { MS_IN_SECOND, SECONDS_IN_HR } from '../../common/constants/private';

// If productionized - will consider relocating logic to conversion-assistant-onboarding -- tracking ticket: https://hello.jira.atlassian.cloud/browse/MOOG-146
export const LS_ONBOARDING_HOLDOUT_KEY = 'rovoOnboardingHoldout';

export const MAX_ONBOARDING_EXPOSURES = 3;

export const HOLDOUT_MS: number = 24 * SECONDS_IN_HR * MS_IN_SECOND;

export type OnboardingHoldoutState = {
	lastSeenAt: number;
	exposureCount: number;
	onboardingCompleted: boolean;
};
